import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

import stringContainsSubOrSupTag from '../utils/stringContainsSubOrSupTag'

const styles = theme => ({
  rootStyle: {
    width: '100%',
    overflowX: 'auto',
    backgroundColor: 'transparent',
    marginTop: 30,
    '@media print': {
      overflowX: 'hidden',
      maxWidth: '210mm'
    }
  },
  tableStyle: {
    minWidth: 700,
    backgroundColor: 'transparent'
  },
  headTableCellStyle: {
    fontFamily: 'Arial-BoldMT, Arial, sans-serif',
    fontWeight: 'bold',
    color: '#303C49',
    fontSize: theme.typography.pxToRem(15),
    borderTop: '1px solid #303C49',
    borderBottom: '1px solid #E2E3E4',
    borderRight: '10px solid transparent',
    padding: 8,
    '&:last-child': {
      borderRight: 'none'
    }
  },
  bodyTableCellStyle: {
    fontFamily: 'MAN-light, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(15),
    borderTop: '1px solid #303C49',
    borderBottom: '1px solid #E2E3E4',
    borderRight: '10px solid transparent',
    padding: 8,
    '&:last-child': {
      borderRight: 'none'
    }
  },
  footnoteListStyle: {
    fontFamily: 'MAN-light, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(15),
    color: '#838A92',
    paddingLeft: '20px',
    margin: '10px 0 10px'
  }
})

const DataTable = ({
  data: { headerRow, rows, footnotes },
  classes: {
    rootStyle,
    tableStyle,
    headTableCellStyle,
    bodyTableCellStyle,
    footnoteListStyle
  }
}) => {
  const showFootnotes = !!footnotes

  return (
    <Paper className={rootStyle} elevation={0} square>
      <Table className={tableStyle}>
        <TableHead>
          <TableRow>
            {headerRow.map(columnHeader => {
              return (
                <TableCell className={headTableCellStyle} key={columnHeader}>
                  {columnHeader}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex} hover>
              {row.map((cell, cellIndex) => {
                if (stringContainsSubOrSupTag(cell)) {
                  return (
                    <TableCell
                      className={bodyTableCellStyle}
                      key={cellIndex}
                      dangerouslySetInnerHTML={{ __html: cell }}
                    />
                  )
                }

                return (
                  <TableCell className={bodyTableCellStyle} key={cellIndex}>
                    {cell}
                  </TableCell>
                )
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {showFootnotes && (
        <div>
          <ol className={footnoteListStyle}>
            {footnotes.map((footnote, index) => (
              <li key={index}>{footnote}</li>
            ))}
          </ol>
        </div>
      )}
    </Paper>
  )
}

export default withStyles(styles)(DataTable)



// WEBPACK FOOTER //
// ./src/components/DataTable.js